export default __webpack_public_path__ + "d8fa88b0c5a0e4f69ed96d13107fd556.png";